<template>
    <section id="change-layout" class="dashboard-change-layout">
        <ds-icon-button
            aria-label="Close modal"
            class="close-modal"
            data-qa="close-modal"
            @click="closeModal"
        >
            <ds-icon name="x" />
        </ds-icon-button>

        <div style="display: grid; grid-row-gap: 1rem; grid-column-gap: 1rem; grid-template-columns: repeat(2, 1fr);padding-top: 10px;">
            <ds-card
                :class="['change-layout', { 'active-layout': isActiveLayout('0') }]"
                @click="changeLayout(0)"
            >
                <ds-card-body>
                    <img
                        src="/slices/dashboard-layout-small.png"
                        height="130"
                        width="180"
                        alt="Small Monitor"
                        data-qa="layout-small"
                    />

                    <div class="layout-description">
                        <p data-qa="small-screen">
                            For small screens
                        </p>

                        <div class="current-layout" data-qa="current-layout">
                            Current Layout
                        </div>
                    </div>
                </ds-card-body>
            </ds-card>

            <ds-card
                :class="['change-layout', { 'active-layout': isActiveLayout('1')}]"
                @click="changeLayout(1)"
            >
                <ds-card-body>
                    <img
                        src="/slices/dashboard-layout-large.png"
                        height="130"
                        width="205"
                        alt="Large Monitor"
                        data-qa="layout-bigger"
                    />

                    <div class="layout-description">
                        <p data-qa="bigger-screen">
                            For bigger screens
                        </p>

                        <div class="current-layout" data-qa="current-layout">
                            Current Layout
                        </div>
                    </div>
                </ds-card-body>
            </ds-card>

            <ds-card
                :class="['change-layout', { 'active-layout': isActiveLayout('2')}]"
                @click="changeLayout(2)"
            >
                <ds-card-body>
                    <img
                        src="/slices/dashboard-layout-xl.png"
                        height="130"
                        width="230"
                        alt="Extra Large Monitor"
                        data-qa="layout-large"
                    />

                    <div class="layout-description">
                        <p data-qa="large-screen">
                            For large screens
                        </p>

                        <div class="current-layout" data-qa="current-layout">
                            Current Layout
                        </div>
                    </div>
                </ds-card-body>
            </ds-card>

            <ds-card
                :class="['change-layout', { 'active-layout': isActiveLayout('3')}]"
                @click="changeLayout(3)"
            >
                <ds-card-body>
                    <img
                        src="/slices/dashboard-layout-xxl.png"
                        height="130"
                        width="260"
                        alt="XXL Monitor"
                        data-qa="layout-wide"
                    />

                    <div class="layout-description">
                        <p data-qa="wide-screen">
                            For super wide screens
                        </p>

                        <div class="current-layout" data-qa="current-layout">
                            Current Layout
                        </div>
                    </div>
                </ds-card-body>
            </ds-card>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        myLayout: Number,
    },

    data() {
        return {
            activeLayout: '',
        };
    },

    computed: {
        isActiveLayout() {
            return (value) => `${this.activeLayout}` === value || (`${this.activeLayout}` === '' && `${this.myLayout}` === value);
        },
    },

    methods: {
        async changeLayout(type) {
            this.activeLayout = type;

            if (type !== this.myLayout) {
                try {
                    await axios.post(`/Dashboard/processChangeLayout.jsp?layout_pref=${type}`);

                    const successMessage = 'Layout changed successfully';

                    this.$toast({ message: successMessage });
                } catch (error) {
                    this.$error({ message: 'Error occurred while changing the layout' });
                }

                setTimeout(() => {
                    this.$emit('reload-page', '');
                    this.closeModal();
                }, 1000);
            }
        },

        closeModal () {
            document.querySelector('span.container-close').click();
        },
    },
};
</script>

<style lang="scss" scoped>
    .dashboard-change-layout {
        padding: 0 $spacing-200  $spacing-250;

        .close-modal {
            grid-area: containerclose;
            position: absolute;
            top: $spacing-100;
            left: $spacing-100;
        }

        .change-layout {
            border: 1px solid transparent;
        }

        .change-layout:hover,
        .active-layout {
            border: 1px solid $color-green;
        }

        .current-layout {
            background-color: $color-green;
            color: $color-white;
            display: inline-block;
            padding: $spacing-050 0.4rem;
            border-radius: 0.3rem;
            font-size: $font-size-xs;
            margin: 0.3rem 0 0;
            height: 1.25rem;
            visibility: hidden;
            line-height: 1;
        }

        .active-layout .current-layout {
            visibility: visible;
        }

        .layout-description {
            text-align: center;
        }

        .layout-description p {
            margin-bottom: 0;
        }

        .change-layout img{
            margin: 0 auto;
            display: block;
        }

        .ds-card {
            width: 18rem;
        }
    }
</style>
